<template>
  <div :class="classes" class="columns register-component">
    <div v-if="$mq.desktop" class="column is-5-desktop is-mobile carousel-section">
      <div class="level btn-container benefits-container tile is-vertical">
        <div>
          <slot name="left-bar"></slot>
        </div>
      </div>
    </div>

    <div class="column is-7-desktop is-mobile form-column">
      <div class="sections-flex-wrapper">

        <section class="form-section form-primary-section">
          <slot name="main-content"></slot>
        </section>
      </div>
    </div>
  </div>
</template>

<script>

import redirects from 'top20common/distribution/services/redirects';

import BenefitsContainer from '@/common/FactsSliderLoginRegister';

export default {
  props: {
    classes: {
      type: String,
      default: () => {
        return '';
      }
    }
  },
  created() {
    if (this.$route.query.next) {
      redirects.saveTargetRouteBeforeLogin(this.$route.query.next);
    }
  },
  components: {
    BenefitsContainer
  }
};
</script>


<style lang="scss" scoped>
@import '~VariablesStyles';
.register-component {
  height: auto;
}
.benefits-container {
  margin-left: 65px;
  margin-top: 180px;
}
.form-column {
  height: auto;
}
.carousel-section {
  min-height: 100vh;
}

.form-primary-section {
  margin-top: 85px;
}

@media screen and (min-width: $tablet) {
  .form-primary-section {
    margin-bottom: 50px;
  }

  .sections-flex-wrapper {
    margin-bottom: 50px;
  }
}
</style>
